import { Sparkles, MessageSquare, Code, Search, Zap, Brain } from 'lucide-react';

interface WelcomeScreenProps {
  onNewChat: () => void;
}

const features = [
  {
    icon: MessageSquare,
    title: 'Natural Conversations',
    description: 'Engage in fluid, context-aware dialogues with DEATH LEGION V1',
  },
  {
    icon: Code,
    title: 'Code & Artifacts',
    description: 'Generate and preview code, HTML, React components, and diagrams',
  },
  {
    icon: Search,
    title: 'Deep Research',
    description: 'Comprehensive research with web search and source synthesis',
  },
  {
    icon: Zap,
    title: 'Operator Mode',
    description: 'Autonomous task execution with multi-step planning',
  },
  {
    icon: Brain,
    title: 'Advanced AI',
    description: 'Powered by Cloudflare Workers AI with multiple model support',
  },
];

const suggestions = [
  'Explain quantum computing in simple terms',
  'Write a React component for a todo list',
  'Create a mermaid diagram of a microservices architecture',
  'Research the latest developments in AI',
  'Help me debug this Python function',
];

export default function WelcomeScreen({ onNewChat }: WelcomeScreenProps) {
  return (
    <div className="h-full flex flex-col items-center justify-center p-8 overflow-y-auto">
      <div className="max-w-4xl w-full text-center">
        {/* Logo */}
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-indigo-500 via-purple-600 to-pink-500 mb-6 animate-pulse-slow">
          <Sparkles className="w-10 h-10 text-white" />
        </div>

        <h1 className="text-4xl font-bold mb-2">
          <span className="gradient-text">DEATH LEGION V1</span>
        </h1>
        <p className="text-xl text-gray-400 mb-8">
          Forged in the digital void by DEMO X HEXA
        </p>

        {/* Suggestions */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-12 max-w-2xl mx-auto">
          {suggestions.map((suggestion, index) => (
            <button
              key={index}
              onClick={() => {
                onNewChat();
                // TODO: Send suggestion as first message
              }}
              className="text-left p-4 bg-legion-card border border-legion-border rounded-xl hover:border-indigo-500/50 hover:bg-legion-card/80 transition-all group"
            >
              <p className="text-sm text-gray-300 group-hover:text-white transition-colors">
                "{suggestion}"
              </p>
            </button>
          ))}
        </div>

        {/* Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-4 bg-legion-card/50 border border-legion-border rounded-xl"
            >
              <feature.icon className="w-6 h-6 text-indigo-400 mb-3 mx-auto" />
              <h3 className="font-medium text-sm mb-1">{feature.title}</h3>
              <p className="text-xs text-gray-500">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Start button */}
        <button
          onClick={() => onNewChat()}
          className="mt-12 px-8 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-medium transition-colors inline-flex items-center gap-2"
        >
          <Sparkles className="w-5 h-5" />
          Start Conversation
        </button>
      </div>
    </div>
  );
}